import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "max-w-md mx-auto mt-8 mb-0 space-y-4"
}
const _hoisted_2 = { class: "text-center mb-6" }
const _hoisted_3 = { class: "text-gray-600" }
const _hoisted_4 = { class: "p-1 shadow-xl bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 rounded-2xl" }
const _hoisted_5 = { class: "block px-6 bg-white sm:p-8 rounded-xl" }
const _hoisted_6 = { class: "mt-2 sm:pr-8" }
const _hoisted_7 = { class: "text-xl font-bold text-gray-900" }
const _hoisted_8 = {
  key: 0,
  class: "mt-2 text-sm text-green-600"
}
const _hoisted_9 = {
  key: 1,
  class: "mt-2 text-sm text-yellow-600"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-medium" }, " Create a password to complete your registration ", -1)
const _hoisted_11 = {
  key: 0,
  class: "text-red-500 text-sm mt-1"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Complete Registration", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5 ml-3",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M14 5l7 7m0 0l-7 7m7-7H3"
  })
], -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "max-w-lg mx-auto mt-8 mb-0 text-center space-y-6"
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto\"><svg class=\"w-10 h-10 text-green-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M5 13l4 4L19 7\"></path></svg></div><h2 class=\"text-2xl font-bold text-gray-900\"> Welcome to Foxwood Crossing! </h2><div class=\"bg-green-50 border border-green-200 rounded-lg p-6 text-left\"><p class=\"text-green-800 font-medium mb-3\">You&#39;re all set!</p><p class=\"text-green-700 text-sm mb-4\"> Your account has been created and your house has been linked. You now have full access to: </p><ul class=\"text-green-700 text-sm space-y-2\"><li class=\"flex items-center\"><svg class=\"w-4 h-4 mr-2\" fill=\"currentColor\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z\" clip-rule=\"evenodd\"></path></svg> Pay HOA dues online </li><li class=\"flex items-center\"><svg class=\"w-4 h-4 mr-2\" fill=\"currentColor\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z\" clip-rule=\"evenodd\"></path></svg> View community events </li><li class=\"flex items-center\"><svg class=\"w-4 h-4 mr-2\" fill=\"currentColor\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z\" clip-rule=\"evenodd\"></path></svg> Post to the neighborhood board </li><li class=\"flex items-center\"><svg class=\"w-4 h-4 mr-2\" fill=\"currentColor\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z\" clip-rule=\"evenodd\"></path></svg> Vote on HOA proposals </li></ul></div><p class=\"text-gray-500 text-sm\"> Check your email for a welcome message with more details. </p>", 4)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Continue to Sign In ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5 ml-2",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M14 5l7 7m0 0l-7 7m7-7H3"
  })
], -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 2,
  class: "max-w-lg mx-auto mt-8 mb-0 text-center space-y-6"
}
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto\"><svg class=\"w-10 h-10 text-yellow-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg></div><h2 class=\"text-2xl font-bold text-gray-900\">Almost There!</h2><div class=\"bg-yellow-50 border border-yellow-200 rounded-lg p-6 text-left\"><p class=\"text-yellow-800 font-medium mb-3\"> Account Created - Verification Pending </p><p class=\"text-yellow-700 text-sm mb-4\"> Your account has been created successfully. Since this house is currently registered to another resident, we need to verify your ownership before granting full access. </p><div class=\"bg-white rounded p-4 border border-yellow-200\"><p class=\"text-gray-700 text-sm font-medium mb-2\">What happens next:</p><ol class=\"text-gray-600 text-sm space-y-2 list-decimal list-inside\"><li>The HOA board will review your request</li><li>This typically takes 1-3 business days</li><li>You&#39;ll receive an email once verified</li></ol></div></div><p class=\"text-gray-500 text-sm\"> Check your email for more details. You can still log in and explore while you wait. </p>", 4)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Continue to Sign In ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5 ml-2",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M14 5l7 7m0 0l-7 7m7-7H3"
  })
], -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 3,
  class: "max-w-lg mx-auto mt-8 mb-0 text-center space-y-6"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-10 h-10 text-red-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M6 18L18 6M6 6l12 12"
    })
  ])
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold text-gray-900" }, "Something Went Wrong", -1)
const _hoisted_34 = { class: "bg-red-50 border border-red-200 rounded-lg p-6" }
const _hoisted_35 = { class: "text-red-700" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-sm" }, [
  /*#__PURE__*/_createTextVNode(" Please try again or contact "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:board@foxwoodcrossing.com",
    class: "text-blue-600 underline"
  }, "board@foxwoodcrossing.com"),
  /*#__PURE__*/_createTextVNode(" for assistance. ")
], -1)

import router from "@/router";
import { HoodApi } from "@/services/HoodApi";
import { PropType, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  selectedHouse: {
    type: Object as PropType<House>,
    required: true,
  },
  user: {
    type: Object as PropType<RegistrationUser>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const password = ref("");
const passwordConfirm = ref("");
const error = ref(false);
const registrationMessage = ref("");
const registrationStatus = ref<"" | "good" | "pending" | "error">("");

const resetErrors = () => {
  error.value = false;
};

const goToLogin = () => {
  router.push("/login");
};

const done = async () => {
  if (password.value !== passwordConfirm.value) {
    error.value = true;
    return;
  }

  const detailsToSubmit = { ...props.user, password: password.value };

  try {
    const result = await HoodApi.register_user(
      detailsToSubmit,
      props.selectedHouse
    );

    if (result.status === "good") {
      registrationStatus.value = "good";
    } else if (result.status === "pending") {
      registrationStatus.value = "pending";
      registrationMessage.value = result.message || "";
    } else {
      registrationStatus.value = "good";
    }
  } catch (err) {
    console.error("Registration error:", err);
    registrationStatus.value = "error";
    registrationMessage.value =
      "Registration failed. Please try again or contact support.";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!registrationStatus.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(__props.user.first_name) + " " + _toDisplayString(__props.user.last_name) + " (" + _toDisplayString(__props.user.email) + ") ", 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h5", _hoisted_7, _toDisplayString(__props.selectedHouse.house_number) + " " + _toDisplayString(__props.selectedHouse.street), 1),
                (__props.selectedHouse.status === 'unclaimed')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, " This house is available and will be linked to your account. "))
                  : (_openBlock(), _createElementBlock("p", _hoisted_9, " This house will require ownership verification. "))
              ])
            ])
          ]),
          _hoisted_10,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["w-full border border-gray-200 p-3 text-sm rounded-lg", { 'border-red-500': error.value }]),
              placeholder: "Password",
              onChange: resetErrors,
              type: "password",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event))
            }, null, 34), [
              [_vModelText, password.value]
            ])
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["w-full border border-gray-200 p-3 text-sm rounded-lg", { 'border-red-500': error.value }]),
              placeholder: "Confirm Password",
              onChange: resetErrors,
              type: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordConfirm).value = $event))
            }, null, 34), [
              [_vModelText, passwordConfirm.value]
            ]),
            (error.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Passwords must match"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            onClick: done,
            class: "inline-flex items-center justify-center w-full px-5 py-3 text-white bg-black rounded-lg sm:w-auto"
          }, _hoisted_14)
        ]))
      : _createCommentVNode("", true),
    (registrationStatus.value === 'good')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("button", {
            onClick: goToLogin,
            class: "inline-flex items-center justify-center px-8 py-3 text-white bg-black rounded-lg font-medium"
          }, _hoisted_22)
        ]))
      : _createCommentVNode("", true),
    (registrationStatus.value === 'pending')
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("button", {
            onClick: goToLogin,
            class: "inline-flex items-center justify-center px-8 py-3 text-white bg-black rounded-lg font-medium"
          }, _hoisted_30)
        ]))
      : _createCommentVNode("", true),
    (registrationStatus.value === 'error')
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _hoisted_32,
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("p", _hoisted_35, _toDisplayString(registrationMessage.value), 1)
          ]),
          _hoisted_36
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})